import { B2C_DEACTIVATE_ACCOUNT, B2C_EMAIL_OTP_PATH, B2C_EMAIL_VERIFY_OTP_PATH, CUSTOMER_AUTH_API_PATH, } from '../../constants/links';
import { apiB2C, apiB2Cjwt } from '../axios-client';
export var b2cAccountApi = {
    getEmailOtp: function (data) {
        return apiB2C.post(B2C_EMAIL_OTP_PATH, data);
    },
    verifyProEmailOtp: function (data) {
        return apiB2C.put(B2C_EMAIL_VERIFY_OTP_PATH, data);
    },
    b2cLogoutAccount: function () {
        return apiB2Cjwt.post(CUSTOMER_AUTH_API_PATH);
    },
    b2cDeactivateAccount: function (data, token) {
        return apiB2C.post(B2C_DEACTIVATE_ACCOUNT, data, {
            headers: {
                'google-auth': token || '',
            },
        });
    },
    // just in case we need to phone otp in the future
    // getPhoneOtp: (
    //   emailId: string,
    //   otpChannel: TOtpChannel,
    //   phoneVerified: string,
    // ): Promise<AxiosResponse<TPhoneOtpResponse>> => {
    //   const params = new URLSearchParams();
    //   params.set('emailId', emailId);
    //   params.set('otpChannel', otpChannel);
    //   params.set('phoneVerified', phoneVerified);
    //   const url = `${B2C_PHONE_OTP_PATH}?${params.toString()}`;
    //   return apiB2C.get(url);
    // },
    // verifyPhoneOtp: (
    //   data: TPhoneVerifyOtpRequest,
    // ): Promise<AxiosResponse<TPhoneVerifyOtpResponse>> => {
    //   return apiB2C.post(B2C_PHONE_VERIFY_OTP_PATH, data);
    // },
};
